/**
 * JwtExpiredError — JWT 만료 시 재로그인 유도
 *
 * 인라인 카드 (오버레이 모달 대신 chat 영역 안에 표시)
 */

import { ShieldAlert, LogIn } from "lucide-react";
import { cn } from "@/shared/lib/utils";

export interface JwtExpiredErrorProps {
  onLogin?: () => void;
  className?: string;
}

export function JwtExpiredError({ onLogin, className }: JwtExpiredErrorProps) {
  return (
    <div
      className={cn(
        "mx-4 mt-3 rounded-xl border border-signal-danger/20 bg-signal-danger/5 px-4 py-3.5",
        className,
      )}
      role="alert"
    >
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 size-4 shrink-0 text-signal-danger" />
        <div className="flex-1 space-y-2">
          <div>
            <p className="text-[13px] font-medium text-signal-danger">
              세션이 만료되었습니다
            </p>
            <p className="mt-0.5 text-[12px] text-text-tertiary">
              보안을 위해 다시 로그인해 주세요.
            </p>
          </div>

          {/* P0 로그인 CTA */}
          <button
            type="button"
            onClick={onLogin}
            className="flex items-center gap-1.5 rounded-lg bg-accent px-4 py-2 text-[13px] font-semibold text-text-inverse shadow-sm hover:bg-accent/90 transition-colors"
          >
            <LogIn className="size-4" />
            <span>다시 로그인</span>
          </button>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════════════
   SessionExpiredOverlay — 전체 오버레이 모달 버전 (선택적 사용)
   ══════════════════════════════════════════════════════════════════════════ */

export interface SessionExpiredOverlayProps {
  onLogin?: () => void;
  className?: string;
}

export function SessionExpiredOverlay({
  onLogin,
  className,
}: SessionExpiredOverlayProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4",
        className,
      )}
    >
      <div className="w-full max-w-sm rounded-2xl border border-stroke-subtle bg-surface-raised p-6 shadow-xl">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex size-12 items-center justify-center rounded-full bg-signal-danger/10">
            <ShieldAlert className="size-6 text-signal-danger" />
          </div>
          <div>
            <h3 className="text-[16px] font-bold text-text-primary">
              세션이 만료되었습니다
            </h3>
            <p className="mt-1 text-[13px] text-text-tertiary">
              보안을 위해 다시 로그인해 주세요. 작업 중이던 내용은 저장됩니다.
            </p>
          </div>
          <button
            type="button"
            onClick={onLogin}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-accent px-6 py-3 text-[14px] font-semibold text-text-inverse shadow-sm hover:bg-accent/90 transition-colors"
          >
            <LogIn className="size-4" />
            다시 로그인
          </button>
        </div>
      </div>
    </div>
  );
}
